import { IAvatar } from "@/components/Avatar";
import CardUserProfile from "@/components/Card/card-user-profile";
import Spinner from "@/components/Spinner";
import { EFilterType } from "@/pages/connections";
import { useMemo } from "react";

export const tier_temporary = (val: number): IAvatar["type_tier"] => {
  if (val >= 5000) return "PLATINUM";
  if (val >= 2000) return "GOLD";
  if (val >= 1000) return "SILVER";
  return "BRONZE";
};

export default function SearchProfiles({
  dataGlobal = [],
  dataConnections = [],
  isLoading,
  filterType,
}: {
  dataGlobal: any;
  dataConnections: any;
  isLoading: boolean;
  filterType?: EFilterType;
}) {
  const dataAfterFilterType = useMemo(() => {
    const sortedDataConnections = [...dataConnections].sort((a: any, b: any) => {
      const lastNameA = a?.user?.lastName?.toLowerCase() ?? '';
      const lastNameB = b?.user?.lastName?.toLowerCase() ?? '';
    
      const firstNameA = a?.user?.firstName?.toLowerCase() ?? '';
      const firstNameB = b?.user?.firstName?.toLowerCase() ?? '';
    
      const lastNameComparison = lastNameA.localeCompare(lastNameB);
      if (lastNameComparison !== 0) {
        return lastNameComparison;
      }
    
      return firstNameA.localeCompare(firstNameB);
    });
    if (!sortedDataConnections) return [];
    if (filterType === EFilterType.ALL) return sortedDataConnections;
    if (filterType === EFilterType.CIRCLE_OF_CHAMPION)
      return sortedDataConnections?.filter((item: any) => item.isChampion);
    const filtered = sortedDataConnections?.filter(
      (x: any) => x?.connectionType === filterType,
    );
    return filtered;
  }, [filterType, dataConnections]);

  return (
    <div>
      <p>
        Profiles{" "}
        {isLoading ? (
          <Spinner size="xs" isTextLoading={false} />
        ) : (
          `(${dataGlobal.length + dataAfterFilterType.length})`
        )}
      </p>

      <div className="bg-card px-4 py-[10px] mt-6">
        <p className="text-sm text-[#D9D9D9]">
          My Connections ({dataAfterFilterType.length})
        </p>
      </div>

      {isLoading ? (
        <div className="pt-10 flex w-full justify-center">
          <Spinner size="lg" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-4 gap-y-20 pt-20">
          {dataAfterFilterType.map((item: any, i: number) => (
            <CardUserProfile
              key={i}
              item={item?.user}
              cgPercent={item?.CGPercent}
              mutualCount={item?.mutualConnectionCount}
              points={item?.user?.points}
              isChampion={item?.isChampion}
            />
          ))}
        </div>
      )}

      <div className="bg-card px-4 py-[10px]  mt-6">
        <p className="text-sm text-[#D9D9D9]">
          Global Search ({dataGlobal.length})
        </p>
      </div>

      {isLoading ? (
        <div className="pt-10 flex w-full justify-center">
          <Spinner size="lg" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-4 gap-y-20 pt-20">
          {dataGlobal.map((item: any, i: number) => (
            <CardUserProfile
              key={i}
              item={item?.user}
              cgPercent={item?.CGPercent}
              mutualCount={item?.mutualConnectionCount}
              points={item?.user?.points}
            />
          ))}
        </div>
      )}
    </div>
  );
}
